/* eslint-disable @typescript-eslint/naming-convention */
import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { ToastController } from '@ionic/angular';
import { ModalController, NavController, PopoverController, LoadingController, AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage';

import { MdlReportesDescargablesPage } from 'src/app/pages/mdl-reportes-descargables/mdl-reportes-descargables.page';
import { MenuPopoverComponent } from '../menu-popover/menu-popover.component';
import { ConexionService } from 'src/app/services/conexion.service';
import { ChatService } from 'src/app/services/chat.service';
import { ValidarToken } from 'src/app/validators/valida-datos';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { GeneralPopoverComponent } from '../general-popover/general-popover.component';
import { PopoverNotificacionesPage } from 'src/app/pages/popover-notificaciones/popover-notificaciones.page';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() business_id: any;
  @Input() wA_id: any;
  @Input() enviosDisponibles: number;

  idAdmin: any;
  idAdminCanal: any;
  idAgente: any;
  classUser: any;

  isMenuVisible: boolean;
  isPopoverIA: boolean;
  informesLeft = false;
  logoLeft = false;
  iaLeft = false;

  isListOpen: boolean;
  isInformesOpen = false;
  isDashboardOpen = false;
  isLicenciasOpen = false;

  isDashboardVisible = false;
  isPlatillasVisible = false;
  isContactosVisible = false;
  isInformesVisible = false;
  isReportesVisible = false;
  isHorariosVisible = false;
  isConfiguracionVisible = false;
  isEnviosDisponiblesVisible = false;

  titulo = '';

  mensaje = '';
  estadoConexion = 'online';
  colorConexion = true;

  loading: HTMLIonLoadingElement;
  imagenSeleccionada = 'assets/perfilDefault.png';

  canal: any;
  canales: any;
  selectCanal: any;
  opcionSeleccionada: string;
  canalBandeja: any;
  idMongo;
  url;
  urlMessenger
  transferencia
  mostrarBannerCache: boolean = false;

  private activeToast: HTMLIonToastElement | null;

  constructor(
    private whatsapp: WhatsappService,
    public chat: ChatService,
    public alertController: AlertController,
    public loadingController: LoadingController,
    private popoverController: PopoverController,
    private router: Router,
    private navCtrl: NavController,
    private modalController: ModalController,
    private eRef: ElementRef,
    private toastController: ToastController,
    private conexion: ConexionService,
    private storage: Storage,
    public authService: AuthService,
  ) {
    this.isMenuVisible = false;
    this.isListOpen = false;
    this.isPopoverIA = false;
    this.canales = [];
    this.opcionSeleccionada = '';
    this.canalBandeja = {};
    this.urlMessenger = null;
    this.activeToast = null;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const clickedInside = this.eRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.closeAllDropdowns();
    }
  }

  ngOnInit() {
    this.getCanal();
    this.seeToast();

    this.classUser = new ValidarToken(this.storage);

    this.storage.get('usuario').then((usuario) => {
      // console.log(usuario, 'este es el usuario');
      this.idAdmin = usuario.idAdmin;
      this.idAgente = usuario.idAgente;
      this.idAdminCanal = usuario.idAdminCanal;
    }).then(() => {
      this.mostrarImagen();
      this.getCanales();
    });

    this.checkUrl();
    this.tituloBoton();

    const opcionGuardada = localStorage.getItem('opcionSeleccionada');
    if (opcionGuardada) {
      this.opcionSeleccionada = opcionGuardada;
    } else {
      this.opcionSeleccionada = '';
    }


  }

  seeToast() {
    this.conexion.estadoConexion$.subscribe(async (estaConectado) => {
      this.estadoConexion = estaConectado ? 'online' : 'offline';
      this.colorConexion = !!estaConectado;

      if (!estaConectado) {
        // OFFLINE → toast fijo si no existe ya
        if (!this.activeToast) {
          const offlineToast = await this.toastController.create({
            message: 'Se ha perdido la conexión a internet',
            duration: 0,
            color: 'danger',
            position: 'bottom',
          });
          this.activeToast = offlineToast;
          await offlineToast.present();

          // limpiar referencia si lo cierran manualmente
          offlineToast.onDidDismiss().then(() => {
            if (this.activeToast === offlineToast) {
              this.activeToast = null;
            }
          });
        }
        this.mensaje = 'Sin Conexión a Internet';
        return;
      }

      // ONLINE → cerrar el toast fijo (si estaba) y luego mostrar “En línea”
      if (this.activeToast) {
        await this.activeToast.dismiss(); // cierra el OFFLINE fijo
        this.activeToast = null;
      }

      const onlineToast = await this.toastController.create({
        message: 'En línea',
        duration: 2000,
        color: 'success',
        position: 'bottom'
      });
      this.activeToast = onlineToast;     // opcional: por consistencia
      await onlineToast.present();
      onlineToast.onDidDismiss().then(() => {
        if (this.activeToast === onlineToast) {
          this.activeToast = null;
        }
      });

      this.mensaje = 'Con Conexión a Internet';
    });
  }

  async menuPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: MenuPopoverComponent,
      event: ev,
      translucent: true,
      mode: 'ios',
      cssClass: 'menuPopover'
    });

    await popover.present();
  }

  async menuGeneral(ev: any, menu) {
    const popover = await this.popoverController.create({
      component: GeneralPopoverComponent,
      componentProps: { selectedMenu: menu },
      event: ev,
      translucent: true,
      mode: 'ios',
      cssClass: 'menuPopover'
    });

    this.opcionSeleccionada = menu;
    localStorage.setItem('opcionSeleccionada', this.opcionSeleccionada);

    await popover.present();
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.selectCanal = new FormControl(this.canal.id);
  }

  getCanales() {
    this.whatsapp.getCanales(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token).subscribe(
      (data: any) => {  // Usa `any` o define un tipo explícito
        // console.log(data, 'canalesssssss header');
        const { status } = data;
        if (status == 'success') {
          this.canales = data.canales;
          this.infoAgente();
          // console.log(this.storage, 'Storage');
        }

      },
      error => {
        console.error(error);
      }
    );
  }

  cambioCanal(ev) {
    const canalNuevo = this.canales.find((canal) => canal.id == ev.detail.value);
    this.storage.remove('canal');
    this.storage.set('canal', canalNuevo);
    this.canal = canalNuevo;
    window.location.reload();
    // console.log(canalNuevo, 'canalNuevo')
  }

  checkUrl() {
    const currentUrl = this.router.url;
    if (currentUrl === '/folder/dashboard-mejorada') {
      this.isDashboardVisible = true;
      this.isPlatillasVisible = true;
      this.isInformesVisible = true;
      this.isConfiguracionVisible = true;
      this.isEnviosDisponiblesVisible = true;
    } else {
      this.isDashboardVisible = true;
      this.isPlatillasVisible = true;
      this.isInformesVisible = true;
      this.isConfiguracionVisible = true;
    }
  }

  tituloBoton() {
    const url = this.router.url;

    if (url === '/folder/inicio') {
      this.titulo = 'Panel de Control';
    } else if (url === '/folder/dashboard-mejorada' || url === '/folder/contactos-unicos' ||
      url === '/folder/dashboard-agentes' || url === '/folder/dashboard-ia' || url === '/folder/dashboard-ceo') {
      this.titulo = 'Dashboard';
    } else if (url === '/folder/plantillas/0' || url === '/folder/plantillas/1' || url === '/folder/crear-encuesta') {
      this.titulo = 'Plantillas';
    } else if (url === '/folder/contacto' || url === '/folder/leads' ||
      url === '/folder/reportes/detalles-chats' || url === '/folder/reportes/productividad-agentes' ||
      url === '/folder/reportes/registro-inicio-sesion' || url === '/folder/reportes/envio-plantillas' ||
      url === '/folder/reportes/encuestas' || url === '/folder/reportes/bandeja-entrada') {
      this.titulo = 'Informes';
    } else if (url === '/folder/crear-licencia' || url === '/folder/crear-equipo' || url === '/folder/visualizar-licencias' ||
      url === '/folder/visualizar-equipo' || url === '/folder/horarios' || url === '/folder/inicio-sesion-dinamico' ||
      url === '/folder/configuracion-ia' || url === '/folder/resultados-operacion' ||
      url === '/folder/respuestas-rapidas' || url === '/folder/lista-negra' || url === '/folder/informacion-contacto'
    ) {
      this.titulo = 'Configuraciónes';
    }
  }

  /*togglePopover() {
    this.isListOpen = !this.isListOpen;
    this.isInformesOpen = false;
    this.isDashboardOpen = false;
    this.isPopoverIA = false;
    this.isLicenciasOpen = false;
    this.opcionSeleccionada = 'plantillas';
    localStorage.setItem('opcionSeleccionada', this.opcionSeleccionada);
    console.log(`Nueva Opción Seleccionada: ${this.opcionSeleccionada}`);
  }

  toggleInformes() {
    this.isInformesOpen = !this.isInformesOpen;
    this.isListOpen = false;
    this.isDashboardOpen = false;
    this.isPopoverIA = false;
    this.isLicenciasOpen = false;
    this.opcionSeleccionada = 'informes';
    localStorage.setItem('opcionSeleccionada', this.opcionSeleccionada);
    console.log(`Nueva Opción Seleccionada: ${this.opcionSeleccionada}`);
  }

  toggleDashboards() {
    this.isDashboardOpen = !this.isDashboardOpen;
    this.isListOpen = false;
    this.isInformesOpen = false;
    this.isPopoverIA = false;
    this.isLicenciasOpen = false;
    this.opcionSeleccionada = 'dashboard';
    localStorage.setItem('opcionSeleccionada', this.opcionSeleccionada);
    console.log(`Nueva Opción Seleccionada: ${this.opcionSeleccionada}`);
  }*/

  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible;
  }

  /*popoverIA() {
    this.isPopoverIA = !this.isPopoverIA;
    this.isListOpen = false;
    this.isDashboardOpen = false;
    this.isInformesOpen = false;
    this.isLicenciasOpen = false;
    this.opcionSeleccionada = 'configuracion';
    localStorage.setItem('opcionSeleccionada', this.opcionSeleccionada);
    console.log(`Nueva Opción Seleccionada: ${this.opcionSeleccionada}`);
  }

  toggleLicencias() {
    this.isLicenciasOpen = !this.isLicenciasOpen;
    this.isListOpen = false;
    this.isDashboardOpen = false;
    this.isInformesOpen = false;
  }*/

  ir(ruta: string) {
    this.navCtrl.navigateForward('/folder/' + ruta).then(() => {
      if (ruta === 'inicio') {
        window.location.reload();
      }
      this.isListOpen = false;
    });
  }

  /*  irUrlMeta(path) {
      if (path === 'estadistica') {
        window.open(`https://business.facebook.com/wa/manage/insights/?business_id=${this.business_id}&waba_id=${this.wA_id}`, '_blank');
      }
  
      if (path === 'resultados') {
        window.open(`https://business.facebook.com/wa/manage/home/?business_id=${this.business_id}&waba_id=${this.wA_id}`, '_blank');
      }
  
      if (path === 'plantillas') {
    eslint-disable-next-line max-len
        window.open(`https://business.facebook.com/wa/manage/message-templates/?business_id=${this.business_id}&waba_id=${this.wA_id}`, '_blank');
      }
    }*/

  async modalReportes() {
    const modal = await this.modalController.create({
      component: MdlReportesDescargablesPage,
      cssClass: 'animate__animated animate__slideInRight',
      showBackdrop: false,
      mode: 'ios',
      componentProps: {
        idAdmin: this.idAdmin,
      },
    });
    return await modal.present();
  }

  closeAllDropdowns() {
    this.isListOpen = false;
    this.isInformesOpen = false;
    this.isDashboardOpen = false;
    this.isPopoverIA = false;
    this.isLicenciasOpen = false;
  }

  triggerFileInput() {
    const fileInput = document.getElementById('btn-logo-an') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  cambiarImagenPerfil(event: any) {
    const archivo = event.target.files[0];
    this.uploadFileMeta(archivo);
  }

  uploadFileMeta(archivo) {
    this.presentLoading('Cargando multimedia');
    const formFile = new FormData();
    formFile.append('file0', archivo);
    formFile.append('file', archivo);

    this.chat.uploadArchivo(formFile, this.classUser.id).subscribe((res: any) => {
      if (res.status === 'success') {
        this.loadingController.dismiss();
        this.imagenSeleccionada = res.result.Location;
        this.cambiarFotoPerfil();
      } else {
        this.loadingController.dismiss();
        this.popoverController.dismiss();
        this.presentAlert('Hubo un error', 'no se pudo cargar archivo', 'por favor intenta de nuevo');
      }
    });
  }

  cambiarFotoPerfil() {
    const dataFoto = { foto: this.imagenSeleccionada };

    this.chat.actualizarFotoPerfil(this.idAdmin, this.idAgente, this.classUser.id, this.classUser.rol, this.classUser.token, dataFoto)
      .subscribe((res: any) => {
        if (res.status === 'success') {
          this.loadingController.dismiss();
          this.popoverController.dismiss();
        } else {
          this.loadingController.dismiss();
          this.popoverController.dismiss();
          this.presentAlert('Hubo un error', 'no se pudo cargar archivo', 'por favor intenta de nuevo');
        }
      });
  }

  mostrarImagen() {
    this.chat.getFotoPerfil(this.idAdmin, this.idAgente, this.classUser.id, this.classUser.rol, this.classUser.token)
      .subscribe((res: any) => {
        if (res.status === 'succeess') {
          this.imagenSeleccionada = res.foto;
        } else {
          this.imagenSeleccionada = 'assets/perfilDefault.png';
        }
      });
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png"></ion-img>'
    });

    await this.loading.present();
  }

  async presentAlert(header, subheader, mensaje) {
    const alert = await this.alertController.create({
      cssClass: 'animate__animated animate__fadeIn',
      header,
      subHeader: subheader,
      message: mensaje,
      buttons: ['OK'],
    });

    await alert.present();
  }

infoAgente() {
  this.authService.getInfoUser(this.idAdminCanal).subscribe((res: any) => {

    console.log(res, 'info user');
    this.idMongo = res['idMongo'];
    this.url = res['url'];
    this.urlMessenger = res['urlFacebookMessenger'];
    this.transferencia = res['transferencia'];
    const apiQuiereMostrar = (res['borrar_cache'] === 1);
    const cacheYaLimpio = localStorage.getItem('cachePresionado'); 
    this.mostrarBannerCache = apiQuiereMostrar && (cacheYaLimpio !== '1');
    
  });
}


clearCache() {
  console.log('Borrando caché y estableciendo bandera...');
  localStorage.setItem('cachePresionado', '1');
  if ('caches' in window) {
    caches.keys().then(names => names.forEach(name => caches.delete(name)));
  }
  // 3. Recargar la app
  window.location.reload();
}



}
